module.exports = __webpack_public_path__ + "img/cmg-labs-1.db264565.jpg";